import { DealerLocationID } from "./DealerLocation";

export interface AAEquipmentTyreScanner {
  created_on: string;
  updated_on: string;
  short_code: number; // Short code attached to the scanner in order to identify it easily
  serial_number: string; // Serial number of the scanner device.
  last_fr_profile_scanned: number; // Last value received from the scanner for this tire position
  last_fl_profile_scanned: number; // Last value received from the scanner for this tire position
  last_rr_profile_scanned: number; // Last value received from the scanner for this tire position
  last_rl_profile_scanned: number; // Last value received from the scanner for this tire position
  last_alignment_recommended_scanned: boolean; // Last value received from the scanner for alignment
  last_report_scanned: string; // Last report received from the scanner
  dealer_location_id: DealerLocationID; // Location Identifier
}
